import business from './api-admin-url/business'
import node from './api-admin-url/node'
import vehicle from './api-admin-url/vehicle'
import workflow from './api-admin-url/workflow'

export default {
  business,
  node,
  vehicle,
  workflow
}
